import { Link } from 'react-router-dom';

const QQ_PORTAL = process.env.REACT_APP_QQ_PORTAL_URL || 'http://localhost:7001/my-tools';
const QQ_CONTACT = QQ_PORTAL.replace('/my-tools', '/contact');

export default function SoftwareLock({ status = 'suspended', companyName }) {
  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: 'linear-gradient(135deg, #f3f6fc 0%, #e8edf7 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, padding: 24,
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    }}>
      {/* Background orbs */}
      <div style={{ position: 'fixed', inset: 0, overflow: 'hidden', pointerEvents: 'none' }}>
        <div style={{ position: 'absolute', width: 600, height: 600, background: 'radial-gradient(circle, rgba(30,105,210,0.08) 0%, transparent 70%)', top: -150, left: -150, borderRadius: '50%' }} />
        <div style={{ position: 'absolute', width: 500, height: 500, background: 'radial-gradient(circle, rgba(239,68,68,0.06) 0%, transparent 70%)', bottom: -150, right: -150, borderRadius: '50%' }} />
      </div>

      <div style={{
        position: 'relative', zIndex: 2,
        background: '#ffffff',
        border: '1px solid rgba(239,68,68,0.22)',
        borderRadius: 24,
        padding: '48px 40px',
        maxWidth: 480, width: '100%',
        textAlign: 'center',
        boxShadow: '0 10px 40px rgba(0,0,0,0.05), 0 20px 50px rgba(30,35,90,0.04)',
      }}>
        {/* Logo */}
        <div style={{ fontSize: 20, fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 900, color: '#0f172a', marginBottom: 28, letterSpacing: '-0.3px' }}>
          <span style={{ color: '#1e69d2' }}>Q</span>uirkyQode
        </div>

        {/* Premium SVG Vector Lock Icon */}
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 26 }}>
          <div style={{
            width: 72, height: 72,
            borderRadius: '50%',
            background: 'rgba(239,68,68,0.06)',
            border: '1px solid rgba(239,68,68,0.22)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 4px 15px rgba(239,68,68,0.08)',
          }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
          </div>
        </div>

        <h1 style={{ fontSize: 24, fontWeight: 800, color: '#0f172a', marginBottom: 14, fontFamily: "'Plus Jakarta Sans', sans-serif", letterSpacing: '-0.5px' }}>
          Access Suspended
        </h1>

        <p style={{ fontSize: 14, color: '#475569', lineHeight: 1.75, marginBottom: 12 }}>
          {companyName && <><strong style={{ color: '#0f172a' }}>{companyName}'s</strong> </>}
          subscription to the <strong style={{ color: '#0f172a' }}>Influencer Marketing</strong> tool is currently{' '}
          <span style={{ color: '#ef4444', fontWeight: 700 }}>{status}</span>.
        </p>

        <p style={{ fontSize: 13, color: '#64748b', lineHeight: 1.7, marginBottom: 32 }}>
          {status === 'expired'
            ? 'Your subscription has expired. Please renew it from the QuirkyQode portal to regain access.'
            : 'Your access has been temporarily suspended. Please contact QuirkyQode support or pay any outstanding invoices.'}
        </p>

        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <a href={QQ_PORTAL} style={{
            background: 'linear-gradient(135deg, #1e69d2, #1558b8)',
            color: '#fff', textDecoration: 'none',
            borderRadius: 12, padding: '12px 24px',
            fontSize: 14, fontWeight: 700,
            boxShadow: '0 4px 14px rgba(30,105,210,0.3)',
            display: 'inline-block',
            transition: 'all 0.2s ease',
          }}>
            Go to QuirkyQode Portal
          </a>
          <a href={QQ_CONTACT} style={{
            background: '#f1f5f9',
            border: '1px solid #cbd5e1',
            color: '#334155', textDecoration: 'none',
            borderRadius: 12, padding: '12px 24px',
            fontSize: 14, fontWeight: 600,
            display: 'inline-block',
            transition: 'all 0.2s ease',
          }}>
            Contact Support
          </a>
        </div>
      </div>
    </div>
  );
}
